import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MyHttpClient } from './http-client.service';
import { HttpClient } from '@angular/common/http';
import { of, Observable, forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HelperService } from './helper.service';


@Injectable()
export class ImsService {

    private cache = {};
    constructor(
        public httpClient: HttpClient
    ) {
    }

    public USER_TYPE = {
        GUEST: 'GUEST',
        HOST: 'HOST',
    };

    accessCookie(cookieName) {
        const name = cookieName + '=';
        const allCookieArray = document.cookie.split(';');
        for (let i = 0; i < allCookieArray.length; i++) {
            if (allCookieArray[i]) {
                const cookieItem = allCookieArray[i].trim();
                if (cookieItem.indexOf(name) === 0) {
                    return cookieItem.substring(name.length, cookieItem.length);
                }
            }
        }
        return '';
    }

    getUserByMobileNumber(mobile: string) {
        const url = `${environment.server}/api/v1/user/profiles`;
        return this.httpClient.get(url, { params: { mobile } });
    }

    updateUserEmail(
        userId: string,
        email: string,
        profileTypes: string[],
        domainType: string
    ) {
        const url = `${environment.server}/api/user/${userId}/email`;
        return this.httpClient.put(url, { email, profileTypes, domainType });
    }

    lookupEmailDomain(email: string) {
        const url = `${environment.server}/api/email-domains/lookup`;
        return this.httpClient.get(url, { params: { email } });
    }

    deleteUserEmail(userId: string) {
        const url = `${environment.server}/api/user/${userId}/email`;
        return this.httpClient.delete(url);
    }

    updateUserName(userId: string, name: string) {
        const url = `${environment.server}/api/user/${userId}/name`;
        return this.httpClient.put(url, { name });
    }
}
